import axios from "axios";

export default {
  state: () => ({
    permissions: [],
  }),
  mutations: {
    setPermissions(state, payload) {
      state.permissions = payload;
    },
  },
  actions: {
    async getPermissions(context) {
      let resp = await axios.get("/permissions");

      if (resp.data.ok) {
        context.commit("setPermissions", resp.data.result);
      }
    },
  },
  getters: {},
};
